import { LoadPanel, TabPanel } from "devextreme-react";
import { Item } from "devextreme-react/tab-panel";
import React, { useEffect, useState } from "react";
// import "../../settings/SettingPage.scss";
import "./Configuration.scss";
import BreadCrumb from "../../../components/breadCrumb/BreadCrumb";
import { HeaderText } from "../../../components/typographyText/TypographyText";
import { useAuth } from "../../../contexts/auth";
import DepartmentTab from "./DepartmentTab/DepartmentTab";
import TagTab from "../../settings/TagTab/TagTab";

export default function Configuration() {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);

  return (
    <>
      {loading && <LoadPanel visible={true} />}
      <div className="wholePage">
         <div className="headerComponent">
                      <div className="headerContainer1">
                        <div className="title">
                          <span class="icon-size">
                            <i class="ri-equalizer-line"></i>
                          </span>
                          {/* <p>Add Client</p> */}
                          <BreadCrumb />
                        </div>
                      </div>
                     
                    </div>
        

        {/* <CustomPageHeader
          titleName={"Settings"}
          handleCreateNew={handleSaveSettingsDetail}
          btnText={"Save Details"}
          iconBool="no"
        /> */}
        {/* <div className="crumbMargin">
          <BreadCrumb />
        </div> */}

        <div className="settingsMain">
          <TabPanel
            width={"100%"}
            height={"100%"}
            animationEnabled={false}
            swipeEnabled={false}
            tabsPosition={"top"}
            stylingMode={"primary"}
          >
            {/* <Item title={"General"}>
              <GeneralTab />
            </Item>
            <Item title={"Status"}>
               <StatusTab/>
            </Item>
            <Item title={"Priority"}>
              <PriorityTab />
            </Item>
            <Item title={"Configuration"}>
              <ConfigurationTab
                getEmails={getEmails}
                assignEmails={assignEmails}
                setAssignEmails={setAssignEmails}
              />
            </Item> */}
            {user?.userrole === "customer" && (
              <Item title={"Department"}>
                <DepartmentTab />
              </Item>
            )}

            <Item title={"Tag"}>
              <TagTab />
            </Item>
          </TabPanel>
        </div>
      </div>
    </>
  );
}
